import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import DefaultLayout from 'ui/layouts/DefaultLayout';
import { privateRoute } from 'env/privateRoute';
import { SupportHeader } from 'ui/_pages/support/SupportHeader';
import LoadingSpinner from 'ui/components/LoadingSpinner';
import { withCustomComponent } from 'ui/components/withCustomComponent';

import CardSupport from 'ui/components/cards/CardSupport';
import { withAppWrapper } from 'ui/components/withAppWrapper';



@withAppWrapper()
@withCustomComponent('SupportPage')
@privateRoute
@withTranslation()
@inject('appStore', 'supportStore')
@observer
class SupportPage extends Component {
  componentDidMount() {
    const { supportStore } = this.props;
    supportStore.loadMessages().catch((err) => {
      appStore.setPopMessage(
        t('Sorry, we could not load this page. {{err}}', { err })
      );
    });
  }
  render() {
    const { t, supportStore, appStore } = this.props;
    const { messages, hasLoadedMessages } = supportStore;
    const { business } = appStore;

    return (
      <DefaultLayout
        componentName={this.props.componentName}
        title={t('Request help - {{Name}}', { Name: business.Name })}
      >
        <main className="content content--custom">
          <div className="container">
            <SupportHeader />
            {!hasLoadedMessages && <LoadingSpinner />}
            {messages.length > 0 && (
              <>
                <h6 className="d-flex align-items-center mb-24">
                  <i className="icon-marker-pin-circle text-gray-600 mr-8"></i>
                  {business.Name}
                </h6>
                <CardSupport header={true} />
                {messages.map((message, i) => (
                  <CardSupport message={message} key={i} />
                ))}
              </>
            )}
          </div>
        </main>
      </DefaultLayout>
    );
  }
}

export default SupportPage;
